/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC, useCallback, useState } from "react";
import {
  ICustomizeSettingTable,
  TableDataAction,
} from "../../types/components/datatable";
import { Table } from "./Table";

export const TableView: FC<ICustomizeSettingTable> = (props) => {
  const {
    deleted,
    onClickToView,
    enabledClickToView,
    setSelectedRows,
    openLink,
    copyLink,
  } = props;
  const [isAction, setIsAction] = useState<boolean>(false);
  const handleSelectRows = useCallback(
    (item) => {
      setTimeout(() => {
        if (!isAction && setSelectedRows) {
          setSelectedRows(item);
        } else if (isAction) {
          setIsAction(false);
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAction]
  );

  const handleGetRowProps = (row) => {
    const isDeleted = deleted && deleted.includes(row?.original?.id);
    return {
      onClick: (e) => {
        if (window.getSelection()?.type === "Range" && !e.shiftKey) return;
        if (
          e.target.attributes?.getNamedItem("data-action")?.value ===
            TableDataAction.ACTION ||
          e.target.parentElement?.attributes?.getNamedItem("data-action")
            ?.value === TableDataAction.ACTION ||
          e.target.parentElement?.parentElement?.attributes?.getNamedItem(
            "data-action"
          )?.value === TableDataAction.ACTION
        ) {
          setIsAction(true);
          return;
        }
        setIsAction(false);
        if (row.original.disabled || isDeleted) return; // disable row select for disabled row

        if (e.ctrlKey && e.button === 0) {
          openLink?.(row);
          return; // disable when ctrl + left click.
        }

        // NOTE: // handle select row to detail for table have onClickToView props
        const tableEnableClickRow =
          onClickToView && // function handle check.
          enabledClickToView; // permission check.

        const allowClickToView =
          tableEnableClickRow &&
          window.getSelection()?.type !== "Range" && // not range (copy)
          e.type === "click" && // click action
          !e.shiftKey && // ignore shift select.
          e.target.attributes?.getNamedItem("data-action")?.value !==
            TableDataAction.SELECTION; // ignore selection and data-action td.
        if (allowClickToView) {
          onClickToView(row);
          return;
        }
      },
      style: {
        ...(isDeleted && {
          cursor: "not-allowed",
          backgroundColor: "#f5f5f5",
        }),
      },
    };
  };
  return (
    <>
      <Table
        {...props}
        setSelectedRows={handleSelectRows}
        getRowProps={handleGetRowProps}
        copyLink={copyLink}
        openLink={openLink}
      />
    </>
  );
};
